import React, { useEffect, Fragment, useState, useRef } from "react";
import Breadcrumb from "../../../../components/common/breadcrumb";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/ToastifyNotification";
import { UncontrolledTooltip } from "reactstrap";
import { GetBillingCharges } from "../../../../api/masters/billingChargesAPI";
import { StoreRoomCategory } from "../../../../api/ipd/roomCategoryAPI";
import useKeyboardSubmit from "../../../../hooks/useKeyboardSubmit";
import useEnterNavigation from "../../../../hooks/useEnterNavigation";

// Validation schema using Yup
const schema = yup.object().shape({
  name: yup.string().required("Name is required"),
  noOfRooms: yup.string().required("No of Rooms is required"),
  billingChargesId: yup.string().required("Billing Charges is required")
});

const AddRoomCategory = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [billingCharges, setBillingCharges] = useState([]);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema)
  });

  const fetchBillingCharges = async () => {
    try {
      const response = await GetBillingCharges(); // Make sure login function returns token
      if (response.success) {
        setBillingCharges(response.data);
      } else {
        // setError(response.message);
        showToast("error", response.message);
      }
    } catch (error) {
      // setError(error); // Handle login errors
      showToast("error", error);
    }
  };

  // Fetch existing data
  useEffect(() => {
    fetchBillingCharges();
  }, []);

  const onSubmit = async data => {
    try {
      dispatch({ type: "LOADER_START" });

      const response = await StoreRoomCategory(data);
      if (response.success) {
        showToast("success", response.message);
        navigate(`/ipd/master/room-category/list`);
      } else {
        showToast("error", response.message);
      }
    } catch (error) {
      showToast("error", error);
    } finally {
      dispatch({ type: "LOADER_STOP" });
    }
  };

  const formRef = useRef(null);
  useKeyboardSubmit(handleSubmit, onSubmit);
  useEnterNavigation(formRef);

  return (
    <Fragment>
      <Breadcrumb parent="Room Category" title="Add Room Category" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <h5>Add Room Category</h5>
                  <Link to={`/ipd/master/room-category/list`}>
                    <button className="btn btn-primary" id="list">
                      List Room Category
                    </button>
                    <UncontrolledTooltip placement="top" target="list">
                      List Room Category
                    </UncontrolledTooltip>
                  </Link>
                </div>
              </div>
              <form
                ref={formRef}
                className="form theme-form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Category Name *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Category Name"
                          {...register("name")}
                        />
                        {errors.name &&
                          <p className="text-danger">
                            {errors.name.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">No of Rooms *</label>
                        <input
                          className="form-control"
                          id="name"
                          type="number"
                          placeholder="No of Rooms"
                          {...register("noOfRooms")}
                        />
                        {errors.noOfRooms &&
                          <p className="text-danger">
                            {errors.noOfRooms.message}
                          </p>}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group">
                        <label htmlFor="name">Billing Charges *</label>
                        <select
                          className="form-control"
                          id="name"
                          type="text"
                          {...register("billingChargesId")}
                        >
                          <option value="">Select Billing Charges</option>
                          {billingCharges.map(billingC =>
                            <option value={billingC._id}>
                              {billingC.name}
                            </option>
                          )}
                        </select>
                        {errors.billingChargesId &&
                          <p className="text-danger">
                            {errors.billingChargesId.message}
                          </p>}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer text-end">
                  <button className="btn btn-primary me-2" type="submit">
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddRoomCategory;
